import React from "react";
import { Link } from "react-router-dom";
import PlanTierCards from "../plans/PlanTierCards";
import { PLANS_TEASER } from "../../utility/aiAssistCopy";

const PricingTiers = () => (
  <section className="bg-brand-cream" aria-labelledby="plans-heading">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="border-t border-brand-charcoal/10 pt-16 md:pt-20 pb-16 md:pb-20">
        <h2
          id="plans-heading"
          className="heading-display text-3xl md:text-4xl"
        >
          Plans
        </h2>
        <div className="mt-3 h-1 w-12 bg-brand-gold" aria-hidden="true" />
        <p className="mt-4 text-brand-muted max-w-2xl">{PLANS_TEASER}</p>
        <p className="mt-3">
          <Link to="/pricing" className="text-sm underline text-brand-gold-ink">
            Plan details
          </Link>
        </p>
        <PlanTierCards location="home_plans" />
      </div>
    </div>
  </section>
);

export default PricingTiers;
